<section class="action-header__section">
  <div
    class="action-header__section__background action-header__section__background--nl action-header__section__background--home visible"
  ></div>

  <div class="action-header__container">
    <div class="action-header__text">
      @if (title && !isFirstSection) {
        <h2 class="action-header__text__title" [innerHTML]="title"></h2>
      }
      @if (title && isFirstSection) {
        <h1 class="action-header__text__title" [innerHTML]="title"></h1>
      }

      @if (!title && description && isFirstSection) {
        <h1
          class="action-header__text__description"
          [innerHTML]="description | unescape"
        ></h1>
      } @else {
        @if (description) {
          <h3
            class="action-header__text__description"
            [innerHTML]="description | unescape"
          ></h3>
        }
      }

      @if (showButton && buttonLink && buttonText) {
        <div class="action-header__button">
          <a [routerLink]="[buttonLink] | localize">{{ buttonText }}</a>
        </div>
      }
    </div>
  </div>
</section>

@if (showStorybrandSteps) {
  <app-storybrand-steps></app-storybrand-steps>
}

@if (showLogoGroup) {
  <app-logo-group></app-logo-group>
}

@if (showEmpathy) {
  <div class="action-header__empathy">
    @if (showLogoGroup) {
      <hr class="action-header__empathy__divider" />
    }
    <h3 class="action-header__empathy__description">
      <div>
        <span>
          <span>
            {{ "texts.ActionHeader_empathy_text1" | translate }}
          </span>
        </span>
        <span class="action-header__empathy__description--highlighted">
          <span>
            {{ "texts.ActionHeader_empathy_text2" | translate }}
          </span>
        </span>
        <span>
          <span>
            {{ "texts.ActionHeader_empathy_text3" | translate }}
          </span>
          <span class="action-header__empathy__description--highlighted">
            <span>
              {{ "texts.ActionHeader_empathy_text4" | translate }}
            </span>
          </span>
          <span>
            <span>
              {{ "texts.ActionHeader_empathy_text5" | translate }}
            </span>
          </span>
        </span>
      </div>
      <div>
        {{ "texts.ActionHeader_empathy_text6" | translate }}
      </div>
    </h3>
  </div>
}
